/**
 * Posible message types
 */
export enum MessageType {
    Status,
    Error,
    Question,
    Warning,
    Confirmation,
    Information
};

/**
 * Icons that represent that message type
 */
export const MessageTypeIcons: string[] = [
    "",                                               // MessageType.Status
    "assets/images/notification_error24.svg",         // MessageType.Error
    "assets/images/notification_question24.svg",      // MessageType.Question
    "assets/images/notification_warning24.svg",       // MessageType.Warning
    "assets/images/notification_success24.svg",       // MessageType.Confirmation
    "assets/images/notification_information24.svg"    // MessageType.Information
];

/**
 * Base message information
 */
export class MessageInfo {
    /**
     * Message type
     */
    messageType: MessageType = MessageType.Status;
    /**
     * Message Text
     */
    message: string = "";
}

export class HeaderBarMessageHeaderInfo extends MessageInfo {

    /**
     * Message icon based on type
     */
    messageIcon: string = "";
    /** 
     * Show/Hide the header bar icon 
     */
    showIcon: boolean = false;
    /** 
     * Show/Hide progress bar 
     */
    showProgress: boolean = false;
    /** 
     * Show/Hide stop button 
     */
    showStop: boolean = false;
    /** 
     * Show/Hide the up caret - which hides the header bar message details 
     */
    showCaretUp: boolean = false;
    /** 
     * Show/Hide the down caret - which shows the  header bar message bar details
     */
    showCaretDown: boolean = false;
    /** 
     * Show/Hide the header bar close icon - which closes the header bar message 
     */
    showClose: boolean = false;

    constructor() {
        super();
    }

    clear(): void {
        this.messageType = MessageType.Status;
        this.message = "";
        this.messageIcon = "";
        this.showIcon = false;
        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
        this.showClose = false;
    }

    setAsStatus(statusMessage: string) {
        this.messageType = MessageType.Status;
        this.message = statusMessage;
        this.showClose = true;

        this.messageIcon = "";
        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
    }

    setAsError(errorMessage: string) {
        this.messageType = MessageType.Error;
        this.message = errorMessage;
        this.messageIcon = MessageTypeIcons[MessageType.Error];
        this.showIcon = true;
        this.showClose = true;

        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
    }

    setAsConfirmation(confirmationMessage: string) {
        this.messageType = MessageType.Confirmation;
        this.message = confirmationMessage;
        this.messageIcon = MessageTypeIcons[MessageType.Confirmation];
        this.showIcon = true;
        this.showClose = true;

        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
    }

    setAsQuestion(questionMessage: string) {
        this.messageType = MessageType.Question;
        this.message = questionMessage;
        this.messageIcon = MessageTypeIcons[MessageType.Question];
        this.showIcon = true;
        this.showClose = true;

        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
    }

    setAsWarning(warningMessage: string) {
        this.messageType = MessageType.Warning;
        this.message = warningMessage;
        this.messageIcon = MessageTypeIcons[MessageType.Warning];
        this.showIcon = true;
        this.showClose = true;

        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
    }

    setAsInformation(informationMessage: string) {
        this.messageType = MessageType.Information;
        this.message = informationMessage;
        this.messageIcon = MessageTypeIcons[MessageType.Information];
        this.showIcon = true;
        this.showClose = true;

        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
    }
}